import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button, Typography } from '@mui/material';

import { imgLinks } from '../../../shared';

import {
  StyledReferralLinkCardDentolo,
  StyledReferralLinkCardDentoloText,
} from './ReferralLinkCardDentolo.styled';

const renderSpanTag = (chunk) => <span>{chunk}</span>;

const ReferralLinkCardDentolo = () => {
  const history = useHistory();

  const handleGotoReferralPage = () => {
    history.push('/referral');
  };

  return (
    <StyledReferralLinkCardDentolo
      backgroundImgDesktop={imgLinks['carousel.referral.dentolo.bg.desktop']}
      backgroundImgMobile={imgLinks['carousel.referral.dentolo.bg.mobile']}
      imgDesktop={imgLinks['carousel.referral.dentolo.image.desktop']}
      imgMobile={imgLinks['carousel.referral.dentolo.image.mobile']}
    >
      <StyledReferralLinkCardDentoloText>
        <Typography variant="h1">
          <FormattedMessage
            id="promotion.carousel.dentolo.referral_link.title"
            values={{
              span: renderSpanTag,
            }}
          />
        </Typography>
      </StyledReferralLinkCardDentoloText>

      <Button onClick={handleGotoReferralPage}>
        <Typography variant="buttons">
          <FormattedMessage id="promotion.carousel.dentolo.referral_link.button.label" />
        </Typography>
      </Button>
    </StyledReferralLinkCardDentolo>
  );
};

export default ReferralLinkCardDentolo;
